import { LoginService } from "src/app/core/services/login";
import { Utils } from "./../../../utils/utils";
import { CommonModule } from "@angular/common";
import { Component, ElementRef, HostListener, OnInit, OnDestroy, Optional, ViewEncapsulation } from "@angular/core";
import { LocalStorage } from "src/app/core/utils";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NbLayoutModule, NbCardModule, NbIconModule, NbTooltipModule, NbListModule, NbPopoverModule, NbMenuModule, NbContextMenuModule, NbTabsetModule, NbToggleModule } from '@nebular/theme';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LccModel, LccSurveysOption, LccSurveysStack } from "src/app/core/models/groups/lcc-model";
import { GruposService } from "src/app/core/services/groups/grupos.service";
import { SOCKETMESSAGES } from "src/app/core/models/socket/socket.constants";
import { SocketService } from "src/app/core/services/socket/socket-service.service";
import { Subject, takeUntil } from "rxjs";
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: "app-modal-chat",
	templateUrl: "./modal-chat.component.html",
	styleUrls: ["./modal-chat.component.scss"],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		NbLayoutModule,
		NbCardModule,
		NbIconModule,
		NbTooltipModule,
		NbToggleModule,
	],
})
export class ModalChatComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();
	idGroup: number = 0;
	showConfigModal: boolean = false;
	isDraggingChat = false;
	dragStartChat = { x: 0, y: 0 };
	chatModalPosition = { top: 100, left: 250 }; // Modal de chat

	emojis = [
		{ icon: "👍", count: 0 },
		{ icon: "👎", count: 0 },
		{ icon: "😢", count: 0 },
		{ icon: "😐", count: 0 },
		{ icon: "😊", count: 0 },
	];
	tags: string[] = [
		this.translateService.instant("CHAT.MSG1"),
		this.translateService.instant("CHAT.MSG2"),
		this.translateService.instant("CHAT.MSG3"),
	];
	selectedEmoji: string | null = null;
	emojiDisabled = false;
	selectedTag: string | null = null;
	tagDisabled = false;

	emojiCountdown: number = 0;
	tagCountdown: number = 0;

	private emojiInterval: any;
	private tagInterval: any;

	tagsProfe: any[] = [];
	userColors: { [id: number]: string } = {};
	verNombre: boolean = true;

	newSurvey: boolean = false;
	pregunta: string = "";
	opciones: string[] = [""];
	multiAnswer: boolean = false;

	surveysList: any[] = [];
	isSubmitting = false;
	surveyDisabled = false;
	surveyCountdown = 60;
	surveyInterval: any;
	selectedSurveyIndex: number | null = null;
	private resizeListener = () => this.setInitialChatModalPosition();
	private generatedStyleElements: HTMLStyleElement[] = [];

	constructor(
		public loginService: LoginService,
		public localStorage: LocalStorage,
		private translateService: TranslateService,
		private groupService: GruposService
	) {
		this.setInitialChatModalPosition();
		window.addEventListener("resize", this.resizeListener);
	}

	ngOnInit() {
		let storedGroupInfo = JSON.parse(localStorage.getItem("selectedGroupInfo"));
		this.idGroup = storedGroupInfo ? storedGroupInfo.idGroup : 0;
		// Verifica si hay bloqueo activo al cargar la página
		this.checkEmojiCooldown();
		this.checkTagCooldown();
		this.checkSurveyCooldown();
		//obtenemos la configuracion del chat
		const storedConfig = localStorage.getItem("chatConfig");
		if (storedConfig) {
			const chatConfig = JSON.parse(storedConfig);
			this.verNombre = chatConfig.verNombre;
		}
		this.obtenerMensajes();
		this.groupService.refreshMessages$
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				this.obtenerMensajes();
			});
	}

	public closeChatModal(): void {
		this.localStorage.removeItem("chatActive");
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.emojiInterval) {
			clearInterval(this.emojiInterval);
		}
		if (this.tagInterval) {
			clearInterval(this.tagInterval);
		}
		if (this.surveyInterval) {
			clearInterval(this.surveyInterval);
		}
		window.removeEventListener("resize", this.resizeListener);
		// Limpiar estilos generados dinámicamente
		this.generatedStyleElements.forEach((el) => {
			if (el.parentNode) {
				el.parentNode.removeChild(el);
			}
		});
		this.generatedStyleElements = [];
	}

	// Inicia el arrastre para el modal correspondiente
	startDragging(event: MouseEvent, modalType: "chat") {
		// Solo permite arrastrar en pantallas que no sean móviles
		if (!this.isMobile()) {
			if (modalType === "chat") {
				this.isDraggingChat = true;
				this.dragStartChat = {
					x: event.clientX - this.chatModalPosition.left,
					y: event.clientY - this.chatModalPosition.top,
				};
				document.addEventListener("mousemove", this.dragModalChat);
				document.addEventListener("mouseup", this.stopDraggingChat);
			}
		}
	}

	// Arrastre del modal de Chat
	dragModalChat = (event: MouseEvent) => {
		if (!this.isDraggingChat) return;
		this.chatModalPosition = {
			top: event.clientY - this.dragStartChat.y,
			left: event.clientX - this.dragStartChat.x,
		};
	};

	// Detener el arrastre del modal de chat
	stopDraggingChat = () => {
		this.isDraggingChat = false;
		document.removeEventListener("mousemove", this.dragModalChat);
		document.removeEventListener("mouseup", this.stopDraggingChat);
	};

	isMobile(): boolean {
		return window.innerWidth <= 768;
	}

	setInitialChatModalPosition() {
		if (this.isMobile()) {
			
			// Centrar el modal en pantalla móvil
			const modalWidth = 320;
			const modalHeight = 400;

			this.chatModalPosition = {
				top: (window.innerHeight - modalHeight) / 2,
				left: (window.innerWidth - modalWidth) / 2,
			};
		} else {
			// Posición por defecto para escritorio
			this.chatModalPosition = { top: 100, left: 250 };
		}
	}

	onEmojiClick(emoji: string) {
		if (this.emojiDisabled) {
			return;
		}
		this.selectedEmoji = emoji;
		this.emojiDisabled = true;
		this.emojiCountdown = 60;
		//guardamos el registro
		this.enviarMsg(emoji);

		const cooldownUntil = Date.now() + 60000;
		localStorage.setItem(
			"emojiCooldown",
			JSON.stringify({ emoji, cooldownUntil })
		);

		this.emojiInterval = setInterval(() => {
			this.emojiCountdown--;
			if (this.emojiCountdown <= 0) {
				this.selectedEmoji = null;
				this.emojiDisabled = false;
				clearInterval(this.emojiInterval);
				localStorage.removeItem("emojiCooldown");
			}
		}, 1000);
	}

	onTagClick(tag: string) {
		if (this.tagDisabled) return;

		this.selectedTag = tag;
		this.tagDisabled = true;
		this.tagCountdown = 60;
		//guardamos el registro
		this.enviarMsg(tag);

		const cooldownUntil = Date.now() + 60000;
		localStorage.setItem("tagCooldown", JSON.stringify({ tag, cooldownUntil }));

		this.tagInterval = setInterval(() => {
			this.tagCountdown--;
			if (this.tagCountdown <= 0) {
				this.selectedTag = null;
				this.tagDisabled = false;
				clearInterval(this.tagInterval);
				localStorage.removeItem("tagCooldown");
			}
		}, 1000);
	}

	enviarMsg(emoji: any) {
		const emojiMap = {
			"👍": { up: 1 },
			"👎": { down: 1 },
			"😢": { face1: 1 },
			"😐": { face2: 1 },
			"😊": { face3: 1 },
		};
		const isReaction = emoji in emojiMap;
		const reaction = isReaction ? emojiMap[emoji] : {};
		const msg = isReaction ? "" : emoji;
		const lcc = new LccModel();
		lcc.idLcc = 0;
		lcc.day = "";
		lcc.hour = "";
		lcc.date = new Date();
		lcc.message = msg;
		lcc.idGroup = this.idGroup;
		lcc.idUser = 0;
		lcc.isTeacher = 0;
		lcc.name = "";
		lcc.face1 = reaction.face1 || 0;
		lcc.face2 = reaction.face2 || 0;
		lcc.face3 = reaction.face3 || 0;
		lcc.up = reaction.up || 0;
		lcc.down = reaction.down || 0;
		this.groupService.createlcc(lcc).subscribe(() => {
			this.groupService
				.sendMsgToRoomClients(
					this.idGroup,
					SOCKETMESSAGES.NEW_STUDENT_MESSAGE,
					this.idGroup
				)
				.subscribe();
		});
	}

	obtenerMensajes() {
		if (this.loginService.esProfesor()) {
			let tagsProfe_aux = [];
			let emojis_aux = [
				{ icon: "👍", count: 0 },
				{ icon: "👎", count: 0 },
				{ icon: "😢", count: 0 },
				{ icon: "😐", count: 0 },
				{ icon: "😊", count: 0 },
			];
			const fecha = new Date();
			const lcc = new LccModel();
			lcc.idGroup = this.idGroup;
			lcc.date = fecha;
			this.groupService.getLccByGroupAndDate(lcc).subscribe((res) => {
				if (res.data.length > 0) {
					//antes que nada obtenemos las encuestas (si las hay)
					this.groupService
						.getLccSurveyByIdGroupAndCreationDate(
							this.idGroup,
							fecha.toISOString().split("T")[0]
						)
						.subscribe((resp) => {
							if (resp.data.length > 0) {
								let surveyList_aux = [];
								for (let index = 0; index < resp.data.length; index++) {
									let srv: any = {
										idLccSurveys: resp.data[index].idLccSurveys,
										question: resp.data[index].question,
										options: JSON.parse(resp.data[index].options),
									};
									surveyList_aux.push(srv);
								}
								this.surveysList = [...surveyList_aux];
							}
							for (let i = 0; i < res.data.length; i++) {
								const element = res.data[i];
								let msg = element.message;
								if (!msg) {
									if (element.up) {
										msg = "👍";
										emojis_aux[0].count++;
									} else if (element.down) {
										msg = "👎";
										emojis_aux[1].count++;
									} else if (element.face1) {
										msg = "😢";
										emojis_aux[2].count++;
									} else if (element.face2) {
										msg = "😐";
										emojis_aux[3].count++;
									} else if (element.face3) {
										msg = "😊";
										emojis_aux[4].count++;
									}
								}
								const isLast = i === res.data.length - 1;
								const className = isLast
									? "nombre-profe"
									: this.getColorClassByUserId(element.idUser);
								const nameProfe = isLast
									? this.translateService.instant("HEADER.PROFESOR")
									: element.name;
								let tag = {
									name: nameProfe,
									msg: msg,
									class: className,
								};
								tagsProfe_aux.unshift(tag);
							}
						});
					this.emojis = emojis_aux;
					this.tagsProfe = tagsProfe_aux;
				} else {
					//creamos el nuevo mensaje
					const lcc = new LccModel();
					lcc.idLcc = 0;
					lcc.day = "";
					lcc.hour = "";
					lcc.date = new Date();
					lcc.message = this.translateService.instant("CHAT.WELCOME");
					lcc.idGroup = this.idGroup;
					lcc.idUser = 0;
					lcc.isTeacher = 1;
					lcc.name = "";
					lcc.face1 = 0;
					lcc.face2 = 0;
					lcc.face3 = 0;
					lcc.up = 0;
					lcc.down = 0;

					this.groupService.createlcc(lcc).subscribe((res) => {
						if (res) {
							this.groupService.getLccByGroupAndDate(lcc).subscribe((res) => {
								if (res.data.length > 0) {
									for (let i = 0; i < res.data.length; i++) {
										const element = res.data[i];
										let msg = element.message;
										if (!msg) {
											if (element.up) {
												msg = "👍";
												emojis_aux[0].count++;
											} else if (element.down) {
												msg = "👎";
												emojis_aux[1].count++;
											} else if (element.face1) {
												msg = "😢";
												emojis_aux[2].count++;
											} else if (element.face2) {
												msg = "😐";
												emojis_aux[3].count++;
											} else if (element.face3) {
												msg = "😊";
												emojis_aux[4].count++;
											}
										}
										const isLast = i === res.data.length - 1;
										const className = isLast
											? "nombre-profe"
											: this.getColorClassByUserId(element.idUser);
										const nameProfe = isLast
											? this.translateService.instant("HEADER.PROFESOR")
											: element.name;
										let tag = {
											name: nameProfe,
											msg: msg,
											class: className,
										};
										tagsProfe_aux.push(tag);
									}
									this.emojis = emojis_aux;
									this.tagsProfe = tagsProfe_aux;
								}
							});
						}
					});
				}
			});
		} else {
			this.groupService
				.getLccSurveyByIdGroupAndCreationDateForStudent(
					this.idGroup,
					new Date().toISOString().split("T")[0]
				)
				.subscribe((res) => {
					if (res.data.length > 0) {
						let surveyList_aux = [];
						let srv: any = {
							idLccSurveys: res.data[0].idLccSurveys,
							question: res.data[0].question,
							multipleAnswer: res.data[0].multipleAnswer,
							options: JSON.parse(res.data[0].options),
						};
						surveyList_aux.push(srv);
						this.surveysList = surveyList_aux;
					}
				});
		}
	}

	getColorClassByUserId(idUser: number): string {
		if (!this.userColors[idUser]) {
			this.userColors[idUser] = this.generateHexColor(idUser);
		}
		return `user-color-${idUser}`;
	}

	generateHexColor(id: number): string {
		// Devolver color cacheado si ya existe para evitar acumular elementos <style>
		if (this.userColors[id]) {
			return this.userColors[id];
		}
		let hash = 0;
		const str = id.toString();
		for (let i = 0; i < str.length; i++) {
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		let color = "#";
		for (let i = 0; i < 3; i++) {
			const value = (hash >> (i * 8)) & 0xff;
			color += ("00" + value.toString(16)).slice(-2);
		}
		const style = document.createElement("style");
		style.innerHTML = `.user-color-${id} { color: ${color} !important; font-weight: bold !important; }`;
		document.head.appendChild(style);
		this.generatedStyleElements.push(style);
		this.userColors[id] = color;
		return color;
	}

	private checkEmojiCooldown() {
		const data = localStorage.getItem("emojiCooldown");
		if (data) {
			const { emoji, cooldownUntil } = JSON.parse(data);
			const now = Date.now();
			if (now < cooldownUntil) {
				this.selectedEmoji = emoji;
				this.emojiDisabled = true;
				this.emojiCountdown = Math.floor((cooldownUntil - now) / 1000);

				this.emojiInterval = setInterval(() => {
					this.emojiCountdown--;
					if (this.emojiCountdown <= 0) {
						this.selectedEmoji = null;
						this.emojiDisabled = false;
						clearInterval(this.emojiInterval);
						localStorage.removeItem("emojiCooldown");
					}
				}, 1000);
			} else {
				localStorage.removeItem("emojiCooldown");
			}
		}
	}

	private checkTagCooldown() {
		const data = localStorage.getItem("tagCooldown");
		if (data) {
			const { tag, cooldownUntil } = JSON.parse(data);
			const now = Date.now();
			if (now < cooldownUntil) {
				this.selectedTag = tag;
				this.tagDisabled = true;
				this.tagCountdown = Math.floor((cooldownUntil - now) / 1000);

				this.tagInterval = setInterval(() => {
					this.tagCountdown--;
					if (this.tagCountdown <= 0) {
						this.selectedTag = null;
						this.tagDisabled = false;
						clearInterval(this.tagInterval);
						localStorage.removeItem("tagCooldown");
					}
				}, 1000);
			} else {
				localStorage.removeItem("tagCooldown");
			}
		}
	}

	checkSurveyCooldown() {
		const cooldownData = localStorage.getItem("surveyCooldown");
		if (cooldownData) {
			const { cooldownUntil, selectedSurveyIndex } = JSON.parse(cooldownData);
			const now = Date.now();
			if (now < cooldownUntil) {
				this.surveyDisabled = true;
				this.selectedSurveyIndex = selectedSurveyIndex;
				this.surveyCountdown = Math.ceil((cooldownUntil - now) / 1000);

				this.surveyInterval = setInterval(() => {
					this.surveyCountdown--;
					if (this.surveyCountdown <= 0) {
						this.surveyDisabled = false;
						this.selectedSurveyIndex = null;
						clearInterval(this.surveyInterval);
						localStorage.removeItem("surveyCooldown");
					}
				}, 1000);
			}
		}
	}

	openConfigModal() {
		this.showConfigModal = !this.showConfigModal;
	}

	isVisibleName(ver: boolean) {
		this.verNombre = ver;
		const chatConfig = {
			verNombre: ver,
		};
		localStorage.setItem("chatConfig", JSON.stringify(chatConfig));
	}

	_newSurvey() {
		this.showConfigModal = !this.showConfigModal;
		this.newSurvey = true;
	}

	enableMultiAnswer(enable: boolean) {
		this.multiAnswer = enable;
	}

	cancelarEncuesta() {
		this.pregunta = "";
		this.opciones = [""];
		this.multiAnswer = false;
		this.newSurvey = false;
	}

	guardarEncuesta() {
		this.groupService
			.createLccSurvey(
				this.idGroup,
				this.multiAnswer,
				this.opciones.filter((op) => op.trim() !== ""),
				this.pregunta
			)
			.subscribe((res) => {
				if (res) {
					this.groupService
						.sendMsgToRoomClients(
							this.idGroup,
							SOCKETMESSAGES.NEW_TEACHER_MESSAGE,
							this.idGroup
						)
						.subscribe();
					this.cancelarEncuesta();
					this.obtenerMensajes();
				}
			});
	}

	agregarOpcion() {
		this.opciones.push("");
	}

	eliminarOpcion(index: number) {
		if (this.opciones.length > 1) {
			this.opciones.splice(index, 1);
		}
	}

	trackByIndex(index: number, item: any): number {
		return index;
	}

	obtenerEncuestaCompleta(
		msg: string
	): { question: string; opciones: { title: string; votos: number }[] } | null {
		const idEncuesta = parseInt(msg.replace("ENCUESTA-", ""));
		const encuesta = this.surveysList.find(
			(e) => e.idLccSurveys === idEncuesta
		);
		if (!encuesta) {
			return null;
		}
		return {
			question: encuesta.question,
			opciones: encuesta.options.map((opt: LccSurveysOption) => ({
				title: opt.title,
				votos: opt.users.length,
			})),
		};
	}

	onOptionClick(survey: any, index: number) {
		if (survey.multipleAnswer) {
			survey.options[index].selected = !survey.options[index].selected;
		} else {
			survey.options.forEach((option: any, i: number) => {
				option.selected = i === index;
			});
		}
	}

	isAnyOptionSelected(survey: any): boolean {
		return survey.options.some((option) => option.selected);
	}

	submitSurvey(index: number) {
		this.isSubmitting = true;
		this.groupService
			.createLccSurveyStack(
				this.idGroup,
				this.surveysList[index].options,
				this.surveysList[index].idLccSurveys
			)
			.subscribe((res) => {
				if (res) {
					//enviamos mensaje al socket
					this.groupService
						.sendMsgToRoomClients(
							this.idGroup,
							SOCKETMESSAGES.NEW_STUDENT_MESSAGE,
							this.idGroup
						)
						.subscribe();
					this.isSubmitting = false;
					this.surveyDisabled = true;
					this.surveyCountdown = 60;
					this.selectedSurveyIndex = index;
					const cooldownUntil = Date.now() + 60000;
					localStorage.setItem(
						"surveyCooldown",
						JSON.stringify({ cooldownUntil, selectedSurveyIndex: index })
					);
					this.surveyInterval = setInterval(() => {
						this.surveyCountdown--;
						if (this.surveyCountdown <= 0) {
							this.surveyDisabled = false;
							this.selectedSurveyIndex = null;
							clearInterval(this.surveyInterval);
							localStorage.removeItem("surveyCooldown");
						}
					}, 1000);
				}
			});
	}

	getPorcentaje(votos: number, opciones: { votos: number }[]): number {
		const total = opciones.reduce((acc, opt) => acc + opt.votos, 0);
		if (total === 0) return 0;
		return (votos / total) * 100;
	}
}
